import React from 'react';
import './SearchToolbar.css';

/* Barra de búsqueda y filtros (F2, ESTANDAR §5 + brief §7):
   [ Buscar…(flex) ] [filtro] [filtro] [filtro] [n resultados]
   · La búsqueda ocupa el mayor espacio horizontal.
   · TODOS los filtros del módulo viven acá, visibles (F4.5, Miguel: el botón
     "Filtros" y el panel AdvancedFilters MURIERON — ningún filtro se esconde
     detrás de un clic). Límite duro: UNA fila ≥1280.
   · UNA fila compacta (regla dura del fold): los chips activos van aparte en
     ActiveFilterChips, solo cuando existen.
   · sticky opcional al hacer scroll (§5). */
export default function SearchToolbar({
  search = '',
  onSearchChange,
  searchPlaceholder = 'Buscar…',
  children = null,          // los filtros del módulo (selects/controles de 40px)
  resultCount,              // número de resultados
  resultText,               // texto contextual que REEMPLAZA al conteo genérico
                            // ("30 pedidos · últimas 2 semanas") — el contador nunca
                            // cuesta una fila propia (regla del fold, hallazgo 6 F3)
                            // OJO (S1#4): `undefined` = este módulo NO tiene contador.
                            // `null` = tiene contador pero todavía no hay dato. Son
                            // cosas distintas y por eso ninguno lleva `= null` por
                            // defecto: eso volvía indistinguible "no hay contador" de
                            // "todavía no cargó".
  trailing = null,          // acciones de la tabla (Exportar, Actualizar — brief §7:
                            // pertenecen a la toolbar, no al bloque de filtros)
  countWidth,               // (S1#4b) ancho RESERVADO del contador, en px. Montarlo
                            // siempre reservaba su presencia, no su ancho: nace vacío
                            // (0px) y se ensancha al llegar el dato. Va POR SITIO
                            // porque el texto cambia mucho entre módulos ("4 pedidos"
                            // 54px contra "96 productos · 522 variaciones" 170px), y
                            // un valor único obligaría a reservar el mayor en todos.
                            // Sin la prop, el contador se comporta como hasta hoy.
  sticky = false,
  className = '',
}) {
  // "Declara contador" = el módulo pasó la prop, aunque valga null por estar
  // cargando. Si no la pasa (undefined), esta toolbar no lleva contador y no se
  // reserva nada.
  const declaraContador = resultText !== undefined || resultCount !== undefined;
  const textoContador = resultText != null
    ? resultText
    : typeof resultCount === 'number'
      ? `${resultCount.toLocaleString('es-CO')} resultado${resultCount === 1 ? '' : 's'}`
      : '';

  return (
    <div className={`ui-toolbar${sticky ? ' ui-toolbar--sticky' : ''}${className ? ` ${className}` : ''}`}>
      {/* Clúster IZQUIERDO explícito (corrección Miguel 2026-07-22: los filtros
          vivían sueltos en el flex y saltaban de posición según el estado —
          agrupados, tienen UNA sola posición siempre: pegados al buscador). */}
      <div className="ui-toolbar-cluster">
        <div className="ui-toolbar-search">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.5" y2="16.5" />
          </svg>
          <input
            type="search"
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
          />
        </div>
        {children}
      </div>
      {/* El contador se monta SIEMPRE que el módulo lo declare, aunque todavía no
          tenga el dato (S1#4). Antes se renderizaba solo con dato: como ocho
          módulos le pasan `loading ? null : …`, el <span> NO EXISTÍA durante toda
          la carga y aparecía tarde — medido a 1440: Catálogo +447 ms, Compras
          +1291 ms, Clientes +1357 ms, Inventario +8790 ms.
          No era solo el contador apareciendo: sin él, el `margin-left:auto` que
          empuja el bloque derecho no existe (lo lleva `.ui-toolbar-count`), así
          que "Exportar/Actualizar" arrancaba pegado a los filtros y saltaba a la
          derecha recién cuando llegaba el conteo. Montado desde el primer paint,
          el bloque derecho nace en su lugar definitivo. */}
      {/* El ancho viaja como custom property, no como `min-width` en línea: el
          estilo en línea le ganaría a las media queries y dejaría el ancho
          clavado también en móvil (misma trampa que se evitó en FilterSelect
          con --fs-w). Como variable, la hoja decide qué hacer con él. */}
      {declaraContador && (
        <span
          className="ui-toolbar-count"
          style={countWidth ? { '--tc-w': `${countWidth}px` } : undefined}
        >
          {textoContador}
        </span>
      )}
      {trailing && <div className="ui-toolbar-trailing">{trailing}</div>}
    </div>
  );
}
